import animateScrollTo from "animated-scroll-to";
import getHeight from "../../../particles/getHeight";
import axios from "axios";
import customSelect from "../../../particles/customSelect";
import notifyOnAdmission from "../../../particles/notifyOnAdmission";
import cart from "../../../particles/cart";
import getCsrfToken from "../../../particles/getCsrfToken";

const html = document.getElementsByTagName('html')[0]

const app = {
  init: () => {
    app.cardInstructions()
    app.cardTabs()
    app.showMoreLessInfo()
    app.initCustomSelect()
    app.review.init()
    notifyOnAdmission.init()
    cart.initCatalogItem()
    cart.initProductCard()

    const quickBuyForm = document.querySelector('#popup-quick-buy form')
    if (quickBuyForm) {
      quickBuyForm.addEventListener('quickBuySuccess', (e) => {
        const apiDto = e.detail.apiDto
        const url = apiDto.data.orderUrl || null
        if (url) {
          window.location = url
        }
      }, false)
    }
  },
  cardInstructions: () => {
    let instructions = document.querySelectorAll('.card__instructions .item__popover-link')
    instructions.forEach((item) => {
      item.addEventListener('click', () => {
        if (window.innerWidth < 768) {
          if (item.parentElement.classList.contains('js_active')) {
            item.parentElement.classList.toggle('js_active')
          } else {
            if (item.closest('.card__instructions').querySelector('.js_active')) {
              item.closest('.card__instructions').querySelector('.js_active').classList.remove('js_active')
            }
            item.parentElement.classList.toggle('js_active')
          }
        } else {
          item.parentElement.querySelector('.modal').classList.add('js_active')
        }
      })
    })
    document.addEventListener('click', (e) => {
      document.querySelectorAll('.card__instructions .modal').forEach((item) => {
        if (!item.contains(e.target) && item !== e.target && !item.closest('.item__popover').contains(e.target)) {
          item.classList.remove('js_active')
        }
      })
    }, false)
  },
  cardTabs: () => {
    let tabDescriptionLink = document.querySelectorAll('.card__description-control a')
    tabDescriptionLink.forEach((item) => {
      item.addEventListener('click', (e) => {
        const tabContainer = document.querySelector('.card__description')
        const tabHeight = html.clientHeight - document.querySelector('.footer').clientHeight - document.querySelector('.subscribe').clientHeight - 42
        if (window.innerWidth >= 768) {
          tabContainer.style.minHeight = tabHeight + 'px'
        }
        if (!item.parentElement.classList.contains('active')) {
          let activeElem = item.closest('.card__description').querySelectorAll('.active')
          activeElem.forEach((elem) => {
            elem.classList.remove('active')
          })
          item.parentElement.classList.add('active')
          item.closest('.card__description').querySelector(item.getAttribute('href')).classList.add('active')
          item.closest('.card__description').querySelector(item.getAttribute('href')).style.minHeight = tabHeight - 60 + 'px'
        } else {
          if (window.innerWidth < 768) {
            item.parentElement.classList.toggle('active')
            item.closest('.card__description').querySelector(item.getAttribute('href')).classList.toggle('active')
          }
        }
        let pos = document.querySelector('.card__description')
        pos = pos.offsetTop - 40
        animateScrollTo(pos)

        e.preventDefault()
      })
    })
  },
  showMoreLessInfo: () => {
    let btnToggle = document.querySelectorAll('.show-more__link')
    btnToggle.forEach((elem) => {
      elem.addEventListener('click', (e) => {
        const clone = elem.closest('.item-box').querySelector('.item-box__content').cloneNode(true)
        const cloneWidth = elem.closest('.item-box').querySelector('.item-box__content').clientWidth
        const testClone = document.createElement('div')
        testClone.setAttribute('style', 'position:fixed; opacity:0; font-size:10px; line-height:17px; z-index:-1;width:' + cloneWidth + 'px')
        testClone.setAttribute('id', 'testClone')
        testClone.appendChild(clone)
        clone.setAttribute('style', 'max-height:none')
        document.querySelector('.card__description').appendChild(testClone)
        let targetHeight = getHeight(clone)
        let box = elem.closest('.item-box')
        box.classList.toggle('_js-box-active')
        if (box.classList.contains('_js-box-active')) {
          elem.closest('.item-box').querySelector('.item-box__content').setAttribute('style', `max-height:${parseInt(targetHeight + 300)}px`) // wrong height, that is +300
        } else {
          elem.closest('.item-box').querySelector('.item-box__content').removeAttribute('style')
        }

        const current = e.target.dataset.text
        e.target.text = (e.target.text === 'Скрыть' ? current : 'Скрыть')
        e.target.parentNode.classList.toggle('js_active')
        e.preventDefault()
      })
    })
  },
  initCustomSelect: () => {
    customSelect.init()

    const settingProductInputs = document.querySelectorAll('.js_product-setting');
    settingProductInputs.forEach((settingProductInput) => {
      settingProductInput.addEventListener('change', (e) => {
        const variant = e.detail.variant || null

        if (variant) {
          const priceDiscount = document.querySelector('.js_props-price-discount-block');
          const price = document.querySelector('.js_props-price-block');
          const notificationBlock = document.querySelector('.js_product-tooltip-price');
          const notificationNote = notificationBlock.querySelector('.js_product-tooltip-price-note');

          let priceDiscountVal = variant.dataset.priceDiscount;
          let priceVal = variant.dataset.price;
          let priceNotificationVal = variant.dataset.priceNotification;

          priceDiscount.innerHTML = priceDiscountVal;
          let isPrice = !!priceVal; // если не выносить в переменную ругается при сборке
          if (isPrice) {
            price.querySelector('.js_props-price-val').innerHTML = priceVal;
            if (priceVal !== priceDiscountVal) {
              price.classList.remove("hidden");
            } else {
              price.classList.add("hidden");
            }
          } else {
            if (priceVal !== priceDiscountVal) {
              price.classList.add("hidden");
            }
          }

          let isPriceNotification = !!priceNotificationVal;

          if (isPriceNotification) {
            notificationBlock.classList.remove("hidden");
            notificationNote.innerHTML = priceNotificationVal;
          } else {
            notificationNote.classList.add("hidden");
            notificationNote.innerHTML = priceNotificationVal
          }
        }
      }, false)
    })
  },
  review: {
    init: () => {
      const likeButtons = document.querySelectorAll('.js_review-rating');
      likeButtons.forEach((likeBtn) => {
        likeBtn.processing = false

        likeBtn.addEventListener('click', (e) => {
          e.preventDefault()

          if (likeBtn.processing === false) {
            likeBtn.processing = true

            axios({
              method: 'post',
              url: likeBtn.href,
              data: {
                _csrf: getCsrfToken(),
              },
              headers: {
                "Content-Type": "application/json",
              },
            }).then((response) => {
              const apiDto = response.data

              app.review.updateRating(likeBtn, apiDto.data)

            }).catch(() => {
            }).finally(() => {
              likeBtn.processing = false
            })
          }
        }, false)
      })
    },
    updateRating: (btn, rating) => {
      const wrapper = btn.parentElement

      const likeWrapper = wrapper.querySelector('.review-item__like .rating-value')
      const dislikeWrapper = wrapper.querySelector('.review-item__unlike .rating-value')

      likeWrapper.innerHTML = rating.like || 0
      dislikeWrapper.innerHTML = rating.dislike || 0
    },
  },
}

export default app
